<template>
  <div>
  <el-dialog custom-class="medium-dialog" title="二维码" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;" class="query-table">
      <tr>
        <td style="text-align: center;width: 60px">序号</td>
        <td style="text-align: center;">名称</td>
        <td style="text-align: center;width:140px;">规格</td>
        <td style="text-align: center;width:140px;">唯一码</td>
        <td style="text-align: center;width:140px;">批次号</td>
      </tr>
      <tr v-for="(item,i) in scancodes">
        <td>{{i+1}}</td>
        <td class="left">{{item["seedname"]}}</td>
        <td>{{getPackagesize(item.packagesize)}}</td>
        <td class="left">{{item["storegoodsbarcode"]}}</td>
        <td class="left"><el-date-picker style="width:100%" size="mini" v-model="item.starttime" :value-format="'yyyy-MM-dd'" type="date"></el-date-picker>
        </td>
      </tr>
    </table>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogFormVisible=false">取 消</el-button>
      <el-button type="primary" @click="createQR">二维码</el-button>
      <el-button type="primary" @click="createQRTM">条 码</el-button>
      <el-select v-model="status" size="mini" style="width: 110px">
        <el-option label="" value=""></el-option>
        <el-option label="首行空1格" value="1"></el-option>
        <el-option label="首行空2格" value="2"></el-option>
      </el-select>
    </div>
  </el-dialog>
  <!--tm38*68hg租户：打码/打印前先选择日期（一次打印所有条码用同一个日期），放在主dialog外面避免被遮挡-->
  <el-dialog title="选择打印日期" :visible.sync="pickDateVisible" width="400px" :close-on-click-modal="false" :append-to-body="true" :modal-append-to-body="true">
    <el-date-picker
      v-model="printdatestr"
      type="date"
      value-format="yyyy-MM-dd"
      :picker-options="datePickerOptions"
      placeholder="请选择日期">
    </el-date-picker>
    <span style="color:#909399;font-size:12px;margin-left:10px;">最多可选到今天起30天内的日期</span>
    <div slot="footer" class="dialog-footer no-print">
      <el-button size="small" @click="cancelPickDate">取 消</el-button>
      <el-button size="small" type="primary" @click="confirmPickDate">确 定</el-button>
    </div>
  </el-dialog>
  </div>
</template>

<script>
  import {listBar,batchSave,printBar} from '@/api/set/jxcstoregoodsbar';
  import {getTenantSet} from '@/api/login';

  export default {
    name: "QRCodeCreate",
    data() {
      return {
        canedit:false,
        issale:false,
        erpserial:'',
        status:'',
        scancodes: [],
        dialogFormVisible: false,
        saveItem: null,
        needPickDate: false,//tm38*68hg租户打码/打印前需选择日期
        printdatestr: '',//选定的打印日期(yyyy-MM-dd)，一次打印所有条码用同一个日期
        pickDateVisible: false,//日期选择弹框
        datePickerOptions: {  //日期限制：最多未来30天，不限制过去日期
          disabledDate: (time) => {
            let today = new Date();
            today.setHours(0, 0, 0, 0);
            let maxDate = new Date(today.getTime() + 30 * 24 * 60 * 60 * 1000);
            return time.getTime() > maxDate.getTime();
          }
        }
      }
    },
    methods: {
      getBarCode(item) {
        getDetail({storegoodsbarcode: item.goodsbarcode}).then(response => {
          if (response.data.code == 0&&response.data.obj) {
            var arr = response.data.obj;
            if (item.seedcode != arr.seedcode) {
              item.goodsbarcode = "";
              this.error('产品编码错误！', item.id)
              return
            }
            if (item.packagesize != arr.packagesize) {
              item.goodsbarcode = "";
              this.error('度数错误！', item.id)
              return
            }

            item.batchno = arr.batchno;
            item.starttime = arr.starttime;
            item.endtime = arr.endtime;
            item.certno = arr.certno;
            item.certorg = arr.certorg;
          }
        });
      },
      getPackagesize(Packagesize) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        var ps = JSON.parse(Packagesize);
        var rl = '';
        if (ps.type)
          rl = ps.type + '，';
        if (ps.M) {
          return ps.M + '/' + ps.C.replace("/", "");
        }

        return rl + 'S：' + ps.Y + ' ， C：' + ps.X;
      },
      error(msg,id) {
        this.$message({
          message: msg,
          type: 'error'
        })
        this.$refs[Object.keys(this.$refs)[id]].focus();
      },
      show(erpserial,issale,canedit,saveitem) {
        this.status='';
        this.erpserial=erpserial;
        this.issale = issale;
        this.canedit = canedit;
        this.saveItem = saveitem;
        if (this.needPickDate) {
          //tm38*68hg租户：先选择打印日期，确认后才打开打码框并加载/入库条码（一次打印用同一个日期），不限制过去日期
          let maxStr = this.dateAddDaysStr(this.todayStr(), 30);
          if (!this.printdatestr || this.printdatestr > maxStr)
            this.printdatestr = this.todayStr();
          this.pickDateVisible = true;
        } else {
          this.dialogFormVisible = true;
          this.loadScancodes();
        }
      },
      //加载已有条码，为空则按订单明细批量入库（tm38*68hg租户入库时间存所选日期）
      loadScancodes() {
        listBar({inordernum: this.erpserial}).then(response => {
          this.scancodes = response.data.obj.rows;
          if (this.scancodes.length == 0) {
            var formdetails = this.saveItem;
            if (this.printdatestr) {
              formdetails = [];
              for (var i in this.saveItem) {
                var item = Object.assign({}, this.saveItem[i]);
                item.intime = this.printdatestr;
                formdetails.push(item);
              }
            }
            batchSave({formdetails: JSON.stringify(formdetails)}).then(resOrder => {
              //保存后重新获取
              listBar({inordernum: this.erpserial}).then(res2 => {
                this.scancodes = res2.data.obj.rows;
              });

            });
          }
        }).catch((error) => {
          console.log(error);
        });
      },
      confirmPickDate() {
        if (!this.printdatestr) {
          this.$message.warning('请选择打印日期！');
          return;
        }
        this.pickDateVisible = false;
        this.dialogFormVisible = true;
        this.loadScancodes();
      },
      cancelPickDate() {
        this.pickDateVisible = false;
        this.dialogFormVisible = false;
      },
      todayStr() {
        let d = new Date();
        let m = d.getMonth() + 1;
        let day = d.getDate();
        return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
      },
      dateAddDaysStr(dateStr, days) {
        let d = new Date(dateStr);
        d.setDate(d.getDate() + days);
        let m = d.getMonth() + 1;
        let day = d.getDate();
        return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
      },
      createQR() {
        printBar(this.erpserial, this.status, '', '', '', this.printdatestr);
        this.dialogFormVisible=false;
      },
      createQRTM() {
        printBar(this.erpserial, this.status, '', '', true, this.printdatestr);
        this.dialogFormVisible = false;
      },
      //给scancodes 添加 id，共回车使用
      indexMethod(index) {
        this.scancodes[index].id = index
        return index + 1;
      }
    },
    mounted() {
      //判断是否tm38*68hg租户：是则打码/打印前需选择日期
      getTenantSet({"website": ''}).then(response => {
        let other = response.data.other;
        if (other && other.frameewmsize == "tm38*68hg") {
          this.needPickDate = true;
        }
      })
    }
    ,
    components: {}
  }
</script>

<style scoped>

  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/testorder/buyagreement/QRCodeCreate.vue